<template>
  <div>
    <Main
      ref="main"
      :disabled="disabled"
      :loading="loading"
      :tablePage="page"
      :tableData="tableData"
      @reload="getData"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <div slot="header">
        <div class="d-flex mt-2">
          <div class="side-frame-danger"></div>
          <div>
            <span style="font-size: 14px; color: #606266">
              {{ $l('table_doc_header_title') || '关联文档' }}
            </span>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
            <b-button
              v-if="!disabled"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="uploadDocVisible = true"
            >
              {{ $l('btn_uploadDoc') || '上传文档' }}
            </b-button>

            <el-badge
              v-if="allow('RB') && !disabled"
              :value="checkedRowCount"
              :hidden="!checkedRowCount"
              class="clearable-button"
              :class="{ clearable: !!checkedRowCount }"
            >
              <b-button
                size="sm"
                class="ml-2"
                variant="outline-primary"
                :disabled="!checkedRowCount"
                @click="readBoxNo"
              >
                {{ $l('btn_readBoxNo') || '智能提取箱贴箱号' }}
                <i
                  class="el-icon-circle-close"
                  @click.stop="clearCheckboxRow"
                />
              </b-button>
            </el-badge>
          </div>
        </div>
      </div>
    </Main>

    <UploadDoc
      :title="$l('dialog_title_uploadDoc') || '上传出库单关联文档'"
      :visible.sync="uploadDocVisible"
      @upload="onUpload"
    />

    <ReadBox
      :visible.sync="readBoxOpts.visible"
      :amzFtyNoticeOutCode="amzFtyNoticeOutCode"
      :listAmzFtyNoticeOutDocCode="readBoxOpts.listAmzFtyNoticeOutDocCode"
      @reload="$emit('reload')"
    />
  </div>
</template>
<script>
import lodash from 'lodash'
import Main from './main.vue'
import BaseTable from '@/mixins/base-table'
import UploadDoc from '../upload-doc'
import ReadBox from '../read-box'
export default {
  mixins: [BaseTable],
  components: { Main, UploadDoc, ReadBox },
  props: {
    disabled: { type: Boolean, default: false },
    amzFtyNoticeOutCode: { type: String, default: '' },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      uploadDocVisible: false,
      checkedRows: [],
      readBoxOpts: { visible: false, listAmzFtyNoticeOutDocCode: [] },
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzFtyNoticeOutCode) return
      this.loading = true
      const res = await this.$api
        .ecomAmzFtyNoticeOutDocListApi({
          amzFtyNoticeOutCode: this.amzFtyNoticeOutCode,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return

      this.tableData = lodash.map(res.body?.data, (row) => ({
        ...row,
        amzFtyNoticeOutDocId: row.amzFtyNoticeOutDocCode,
      }))
    },
    onUpload(data) {
      if (!data) return
      this.$refs.main.insertAt(data)
    },
    validate() {
      return this.$refs.main.validate()
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    async readBoxNo() {
      if (!this.checkedRowCount) {
        this.$message({
          message: '请选择需要提取箱贴箱号的文件',
          type: 'warning',
        })
        return
      }

      const listAmzFtyNoticeOutDocCode = lodash.map(
        this.checkedRows,
        'amzFtyNoticeOutDocCode'
      )

      this.readBoxOpts = { visible: true, listAmzFtyNoticeOutDocCode }
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-danger {
  padding: 1px 5px;
  border-left: 3px solid $color-danger;
  height: 20px;
  margin-top: 3px;
}

.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
